import { SITE } from '../config/site';

/**
 * FAQ content. Extracted from the FAQ component so the same source can drive
 * both the rendered accordion and the FAQPage structured data — keeping them
 * from drifting apart.
 */
export const faqSections = [
    {
        category: 'Généralités & Abonnement',
        questions: [
            {
                question: "Qu'est-ce que l'IPTV et comment ça marche ?",
                answer: `L'IPTV (Internet Protocol Television) est une technologie qui permet de diffuser des chaînes de télévision et des contenus vidéo via votre connexion internet, sans passer par une antenne satellite ou un câble traditionnel. Avec ${SITE.name}, vous accédez instantanément à plus de 79 000 chaînes et VOD en connectant simplement votre appareil (Smart TV, Box Android, Smartphone) à internet.`,
            },
            {
                question: `Quels sont les appareils compatibles avec ${SITE.name} ?`,
                answer: "Notre service IPTV est compatible avec la quasi-totalité des appareils connectés : Smart TV (Samsung, LG, Sony, Android TV, etc.), Boîtiers Android (Nvidia Shield, Xiaomi Mi Box), Fire TV Stick, Apple TV, Smartphones et Tablettes (iOS & Android), PC/Mac (via VLC ou Smarters Pro) et les boîtiers MAG.",
            },
            {
                question: 'Puis-je utiliser mon abonnement sur plusieurs écrans ?',
                answer: "Oui, nous proposons des options multi-écrans. Selon votre forfait, vous pouvez regarder vos programmes sur 1 à 4 appareils simultanément. C'est idéal pour partager votre abonnement avec votre famille ou vos amis.",
            },
            {
                question: 'Proposez-vous un test gratuit avant l\'achat ?',
                answer: "Absolument ! Nous sommes convaincus de la qualité de notre service. Vous pouvez demander un test gratuit de 24h pour vérifier la stabilité, la qualité d'image (4K/FHD) et la richesse de notre catalogue avant de vous engager.",
            },
        ],
    },
    {
        category: 'Installation & Technique',
        questions: [
            {
                question: 'Comment installer l\'IPTV sur ma Smart TV ?',
                answer: "L'installation est très simple. Pour les Smart TV Samsung ou LG, nous recommandons l'application « IPTV Smarters Pro » ou « IBO Player ». Une fois l'application installée, il vous suffit d'entrer les identifiants (Xtream Codes ou lien M3U) que nous vous envoyons par email après votre commande.",
            },
            {
                question: 'Quelle vitesse internet est nécessaire pour la 4K ?',
                answer: "Pour une expérience fluide en 4K UHD, nous recommandons une vitesse de connexion stable d'au moins 25 Mbps. Pour la Full HD (1080p), 10 Mbps suffisent. La fibre optique est idéale, mais une bonne connexion ADSL ou 4G/5G fonctionne également très bien.",
            },
            {
                question: 'Que faire en cas de coupures ou de buffering ?',
                answer: "Si vous rencontrez des ralentissements, vérifiez d'abord votre connexion internet (redémarrez votre routeur). Assurez-vous d'utiliser un câble Ethernet si possible plutôt que le Wi-Fi. Si le problème persiste, notre support technique est disponible 7j/7 pour vous aider à optimiser vos réglages.",
            },
            {
                question: `Ai-je besoin d'un VPN pour utiliser ${SITE.name} ?`,
                answer: "L'utilisation d'un VPN n'est pas obligatoire mais peut être recommandée si votre fournisseur d'accès internet (FAI) bride votre connexion lors du streaming. Notre service est compatible avec tous les principaux VPN du marché (NordVPN, ExpressVPN, CyberGhost, etc.).",
            },
        ],
    },
    {
        category: 'Paiement & Support',
        questions: [
            {
                question: 'Quels sont les moyens de paiement acceptés ?',
                answer: 'Nous acceptons les paiements sécurisés par Carte Bancaire (Visa, Mastercard), PayPal, Bancontact et crypto-monnaies. Toutes les transactions sont chiffrées et sécurisées.',
            },
            {
                question: 'En combien de temps reçois-je mes accès ?',
                answer: "La livraison est automatisée et quasi-instantanée. Vous recevrez vos codes d'accès et le guide d'installation par email dans les 5 à 15 minutes suivant la validation de votre paiement.",
            },
            {
                // NOTE: the exact duration is intentionally not repeated here.
                // The plan cards, this FAQ and /refund previously stated three
                // different durations; the refund policy page is the single
                // authoritative source until that is reconciled.
                question: 'Proposez-vous une garantie satisfait ou remboursé ?',
                answer: "Oui. La durée de la garantie applicable est indiquée sur chaque forfait, et les conditions détaillées figurent dans notre politique de remboursement. Si vous rencontrez un problème technique que notre support ne parvient pas à résoudre, nous vous remboursons.",
            },
        ],
    },
];

/** Flat list of every question, used to build the FAQPage JSON-LD. */
export const allFaqs = faqSections.flatMap((section) => section.questions);
